import axios from './index'

class order {
  //确认预约
  static sureMakeSubmit(options) {
    return axios.post(`/nice-api-order/v1/bookingsOrder/customer/confirm`,options);
  }

  //获取客户预约单 tab=1
  static getBookingsOrder(options) {
    return axios.get('/nice-api-order/v1/bookingsOrder/customer', {params:options});
  }

  //根据ID获取预约单详情
  static getBookingsById(options) {
    return axios.get(`/nice-api-order/v1/bookingsOrder/${options}`);
  }
  
    //根据ID获取预约单详情2
    static getOtherBookingsById(options) {
      return axios.get(`/nice-api-order/v1/bookingsOrder/customerService/customer`, {params:options});
    }

  //获取取消原因
  static getCancelReason(options) {
    return axios.get(`/nice-api-order/v1/bookingsOrder/cancel/list`);
  }

  //获取快递平台
  static getExpressPlatform(options) {
    return axios.get(`/nice-api-order/v1/package/expressPlatform`);
  }

  //取消预约单
  static cancelBookingsOrder(options) {
    return axios.patch(`/nice-api-order/v1/bookingsOrder/cancel`,options);
  }

  //添加快递单号
  static addPackage(options) {
    return axios.post(`/nice-api-order/v1/package`,options);
  }

    //获取在线服务商品
    static getOnlineList() {
      return axios.get(`/nice-api-order/v1/virtualGoods/customer/planning?type=10`);
    }

    //获取上门服务商品
    static getOndoorList() {
      return axios.get(`/nice-api-order/v1/virtualGoods/customer/planning?type=20`);
    }

  //根据商品状态获取客户商品
  static getGoodsList(options) {
    return axios.get(`/nice-api-order/v1/goods/customer/planning`);
  }


  //根据商品状态获取客户商品
  static customerServiceList(options) {
    return axios.get(`/nice-api-order/v1/goods/customerService/planning`,{params:options});
  }
  


  
  //根据商品状态获取客户商品
  static waitDelivery(options) {
    return axios.get(`/nice-api-order/v1/goods/customer/waitDelivery`);
  }

  //根据商品状态获取客户商品
  static waitDeliveryCustomer(options) {
    return axios.get(`/nice-api-order/v1/goods/customerService/waitDelivery`,{params:options});
  }

  

  //根据商品状态获取客户商品
  static maintaining(options) {
    return axios.get(`/nice-api-order/v1/goods/customer/maintaining`);
  }
  
  

  //根据商品状态获取客户商品
  static getOtherGoodsList(options) {
    return axios.get(`/nice-api-order/v1/goods/customerService`,{params:options});
  }

  //根据商品获取诊断详情
  static getDiagnose(options) {
    if(!options){
      return;
    }
    return axios.get(`/nice-api-order/v1/goods/${options}/diagnose`);
  }

  //根据商品获取服务项
  static goodsCuringService(options) {
    return axios.get(`/nice-api-order/v1/goodsCuringService/goods/${options}`);
  }
  //用户选择服务项
  static setEmployService(options) {
    return axios.patch(`/nice-api-order/v1/goodsCuringService/employ`,options);
  }

  //在线服务详情-宝贝相册
  static getPhotoList(options) {
    return axios.get(`/nice-api-order/v1/virtualGoods/photo`,{params:options});
  }

  //诊断图集
  static getPhotos(options) {
    if(!options){
      return;
    }
    return axios.get(`/nice-api-order/v1/goodsPhoto/goods/${options}`);
  }

  //诊断图集
  static getPhotosByGoodsCode(options) {
    return axios.get(`/nice-api-order/v1/goodsPhoto/customerService/goods/${options}`);
  }
    
  //获得效果方案
  static getEffects(options) {
    return axios.get(`/nice-api-order/v1/goods/${options}/effect`);
  }

  //获得效果方案
  static getEffectsEid(options) {
    return axios.get(`/nice-api-order/v1/goods/customerService/${options}/effect`);
  }
  
  //客服获得诊断方案
  static getDiagnoseByGoodcode(options) {
    return axios.get(`/nice-api-order/v1/goods/customerService/${options}/diagnose`);
  }
  

  //判断是否可打包寄回
  static judgePackageDelivery(options) {
    return axios.post(`/nice-api-order/v1/goods/judgePackageDelivery`,options);
  }

  //打包寄回
  static packageDelivery(options) {
    return axios.post(`/nice-api-order/v1/goods/packageDelivery`,options);
  }

  //已完成在线订单
  static getComOnlineOrder(options) {
    return axios.get(`/nice-api-order/v1/virtualGoods/customer/complete`,{params:options});
  }

  //查看客户送货单
  static getDeliveryOrder(options) {
    return axios.get(`/nice-api-order/v1/deliveryOrder`,{params:options});
  }

  //确认收货
  static received(options) {
    return axios.patch(`/nice-api-order/v1/deliveryOrder/${options}/received`);
  }

  //商品取消修复
  static goodsCancel(options) {
    return axios.patch(`/nice-api-order/v1/goods/${options.id}/cancel`,options);
  }

  //获取几个tab的商品数量
  static getGoodsNumber(options) {
    return axios.get(`/nice-api-order/v1/goods/tip/number`,options);
  }

  //不可修复取消接口
  static cancelByBeyondRepair(options) {
    return axios.patch(`/nice-api-order/v1/goods/${options}/cancelByBeyondRepair`,{cancelReasonId: 144});
  }
    
  //商品订单-生成订单
  static orderscheme(options) {
    return axios.post(`/nice-api-order/v1/scheme`,options);
  }

  //行为通知
  static behavior(options) {
    return axios.get(`/nice-api-order/v1/goods/customer/behavior`,{params:options});
  }
  
  //分享配置
  static shareConfig(options) {
    return axios.get(`/nice-api-customer/v1/other/share/config`,{params:options});
  }

  //分享日志
  static shareLog(options) {
    return axios.post(`/nice-api-order/v1/debug/share`,options);
  }
  

  //获取结算单
  static unpaid(options) {
    return axios.get(`/nice-api-order/v1/settlement/customer/unpaid`);
  }

  //获取结算单详情
  static settlemenDetail(settlementCode) {
    return axios.get(`/nice-api-order/v1/settlement/${settlementCode}/data`);
  }
  
    

  //再次结算
  static settlementCodePayment(params) {
    return axios.post(`/nice-api-order/v1/settlement/${params.settlementCode}/payment`,params);
  }

  //取消结算
  
  static settlementConcel(settlementId) {
    return axios.post(`/nice-api-order/v1/settlement/${settlementId}/cancel`);
  }

  //拉取顺丰物流信息
  static listRouteInfo(bookingsOrderCode) {
    return axios.get(`/nice-api-order/express/listRouteInfo/${bookingsOrderCode}`);
  }

  //再次寄出
  static sendNow(option) {
    return axios.post(`/nice-api-order/v1/bookingsOrder/send-now`,option);
  }

  //添加地址
  static orderAddress(option) {
    return axios.post(`/nice-api-order/v1/bookingsOrderAddress`,option);
  }


  //验证
  static getOrderAddress(option) {
    return axios.get(`/nice-api-order/v1/bookingsOrderAddress`,{params:option});
  }

  //修改地址
  static patchOrderAddress(option) {
    return axios.patch(`/nice-api-order/v1/bookingsOrderAddress`,option);
  }

  //修改预约
  static postWay(option) {
    return axios.patch(`/nice-api-order/v1/bookingsOrder/postWay/change`,option);
  }
  
  //获取优惠券
  static getShareCoupons(option) {
    return axios.get(`/nice-api-customer/v1/coupon/customer/getShareGiftCoupons`,option);
  }
  
  //领取优惠券
  static setShareCoupons(option) {
    return axios.post(`/nice-api-customer/v1/coupon/customer/drawShareGiftCoupon/${option}`);
  }

  //领取优惠券
  static shareBatchCode(option) {
    return axios.get(`/nice-api-customer/v1/coupon/customer/shareBatchCode`);
  }

  static deliveRoute(option) {
    return axios.get(`/nice-api-order/v1/deliveryOrder/route/${option}`);
  }
  static getBargainActivity() {
    return axios.get(`/nice-api-customer/v1/bargainActivity`);
  }

  static recordInfo(bargainActivityId) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/${bargainActivityId}/recordInfo`);
  }

  static expressDetail(id,option) {
    return axios.get(`/nice-api-order/v1/deliveryOrder/route/${id}`,{params:option});
  }

  static speedMsg(id) {
    return axios.get(`/nice-api-order/v1/view/progress/diagnosis/detail/${id}`);
  }

  static reminder(id) {
    return axios.patch(`/nice-api-order/v1/view/progress/urge/${id}`);
  }

  static searchTags(id) {
    return axios.get(`/nice-api-customer/v1/evaluate/tags/${id}`);
  }
  static getLastOrder() {
    return axios.get(`/nice-api-customer/v1/evaluate/orderCode`);
  }
  static addEvaluate(option) {
    return axios.post(`/nice-api-customer/v1/evaluate`,option);
  }
  
  
}

export default order;
